import {useEffect} from 'react'

import {noop} from '@sdox/utils'

export const useEscapeKey = (handleFn = noop) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      e.stopPropagation()
      if (e.key === 'Escape') {
        handleFn()
      }
    }

    document.addEventListener('keyup', handleKey)

    return () => {
      document.removeEventListener('keyup', handleKey)
    }
  }, [handleFn])
}